module.exports = __webpack_public_path__ + "img/安宁市中医医院.2006b791.png";